import React, { useState, useRef, useEffect } from 'react';
import NavigationMenu from '../components/NavigationMenu';
import LogoBlanc from '../components/LogoBlanc';
import './References.css';

const References = () => {
  const [selectedRef, setSelectedRef]       = useState(null);
  const [hoveredRef, setHoveredRef]         = useState(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isDragging, setIsDragging]         = useState(false);
  const [isDashboardOpen, setIsDashboardOpen] = useState(true); // Tableau de bord ouvert par défaut
  const [hoveredDashItem, setHoveredDashItem] = useState(null);
  const carouselRef  = useRef(null);
  const scrollbarRef = useRef(null);

  // ── Données — à remplir avec vos références ───────────────
  // Structure : { id, name, artist, image, images[], embedUrl,
  //   years, nature, techniques, description, links[] }
  const references = [
    {
      id: 1,
      name: 'Dhatu',
      artist: 'James Turrell',
      image: '/media/references/JamesTurrell/BREATHINGLIGHT_turrellj.jpg',
      images: ['/media/references/JamesTurrell/BREATHINGLIGHT_turrellj.jpg', '/media/references/JamesTurrell/Breathing-Light-2013-Florian-LACMA-3c1.jpg', '/media/references/JamesTurrell/213128_015.jpg', '/media/references/JamesTurrell/JAMES-TURRELL-2010_Dhatu-JPEG-595x393.jpg'],
      embedUrl: '',
      years: '2010',
      nature: 'Installation immersive',
      techniques: 'projection lumineuse',
      description: 'Dhatu fait partie de la série Ganzfeld de James Turrell qui regroupe des installations immersives où les visiteurs entrent dans une pièce sans limites apparentes, baignée d`une lumière colorée et changeante pour abolir la perception de la profondeur et des angles. Les visiteurs entrent dans une vaste chambre architecturale vide où les repères spatiaux, les coins et la sensation de profondeur s`évanouissent complètement. Des séquences de lumières LED changeantes baignent l`espace entier, modifiant lentement la perception visuelle du spectateur.Perception humaine : L`œuvre questionne notre façon de construire notre propre réalité en démontrant les limites et la malléabilité de nos sens.',
      links: ['https://jamesturrell.com/'],
    },
    {
      id: 2,
      name: 'Bridget`s Bardo',
      artist: 'James Turrell',
      image: '/media/references/JamesTurrell/Jarna_Armta_11.jpg',
      images: ['/media/references/JamesTurrell/Jarna_Armta_11.jpg', '/media/references/JamesTurrell/beacon-of-light-the-seven-best-james-turrell-works-youve-never-heard-of-900x450-c.jpg'],
      embedUrl: '',
      years: '2008',
      nature: 'Installation immersive',
      techniques: 'projection lumineuse',
      description: 'Bridget`s Bardo fait partie de la série Ganzfeld de James Turrell qui regroupe des installations immersives où les visiteurs entrent dans une pièce sans limites apparentes, baignée d`une lumière colorée et changeante pour abolir la perception de la profondeur et des angles. Les visiteurs entrent dans une vaste chambre architecturale vide où les repères spatiaux, les coins et la sensation de profondeur s`évanouissent complètement. Des séquences de lumières LED changeantes baignent l`espace entier, modifiant lentement la perception visuelle du spectateur.Perception humaine : L`œuvre questionne notre façon de construire notre propre réalité en démontrant les limites et la malléabilité de nos sens.',
      links: ['https://jamesturrell.com/'],
    },
        {
      id: 3,
      name: 'The Weather Project',
      artist: 'Ólafur Elíasson',
      image: '/media/references/OlafurEliasson/Olafur-Eliasson-The-Weather-Project-2003-Tate-Modern-London-Dan-Chung-Guardian.jpg',
      images: ['/media/references/OlafurEliasson/Olafur-Eliasson-The-Weather-Project-2003-Tate-Modern-London-Dan-Chung-Guardian.jpg', '/media/references/OlafurEliasson/1885.jpg', '/media/references/OlafurEliasson/1-of-14-The-weather-project-2003-Tate-Modern-London-2003-Photo-Andrew-Dunkley-Marcus-Leith-1305x940.jpg'],
      embedUrl: 'https://www.youtube.com/embed/kYAaZ53tazU',
      years: '2003',
      nature: 'Installation immersive',
      techniques: 'installation lumineuse (~200 ampoules), machine à fumée, miroirs',
      description: 'The Weather Project est une installation du plasticien islando-danois Ólafur Elíasson exposée à la Tate Modern de Londres en 2003. Elle évoque un grand soleil jaune éclairant la pièce où se tiennent les visiteurs.',
      links: ['https://olafureliasson.net/artwork/the-weather-project-2003/'],
    },
            {
      id: 4,
      name: 'Feel',
      artist: 'Aleix Fernandez',
      image: '/media/references/AleixFernandez/image-asset (1).jpeg',
      images: ['/media/references/AleixFernandez/image-asset (1).jpeg', '/media/references/AleixFernandez/image-asset.jpeg', '/media/references/AleixFernandez/image-asset (3).jpeg'],
      embedUrl: 'https://player.vimeo.com/video/123456789',
      years: '2017',
      nature: 'Installation immersive',
      techniques: 'panneau led',
      description: '',
      links: ['https://olafureliasson.net/artwork/the-weather-project-2003/'],
    },
                {
      id: 5,
      name: 'C.H.Z.',
      artist: 'Philippe Parreno',
      image: '/media/references/PhilippeParreno/Phillipe-9-CHZ-5.jpg',
      images: ['/media/references/PhilippeParreno/Phillipe-9-CHZ-5.jpg', '/media/references/PhilippeParreno/parreno_chz2.jpg.crop_display.jpg', '/media/references/PhilippeParreno/Continuously_habitable_zones_aka_C_H_Z.jpg', '/media/references/PhilippeParreno/Parreno_CHZ_still61-1400x787.jpg'],
      years: '2011',
      nature: 'Installation',
      techniques: 'scénographie, lumière, captation, écriture de science-fiction conceptuelle',
      description: 'C.H.Z. (Continuously Habitable Zones) est un film de science-fiction et une installation artistique créé en 2011 par l`artiste français Philippe Parreno. Le nom : « C.H.Z. » vient d`un terme astronomique (Continuously Habitable Zone) désignant les zones habitables d`une planète où la vie peut se développer.',
      links: [],
    },
                    {
      id: 6,
      name: 'Continuum',
      artist: 'Félicie d’Estienne d’Orves',
      image: '/media/references/FelicieDEstienneDOrves/10_conti-1024x576.jpg',
      images: ['/media/references/FelicieDEstienneDOrves/10_conti-1024x576.jpg', '/media/references/FelicieDEstienneDOrves/Continuum2.webp', '/media/references/FelicieDEstienneDOrves/Com_Felicie_DestienneDorves_Contuum_C-JulienLanoo_20190518_09376-copy-1300x867.jpg'],
      embedUrl: 'https://www.youtube.com/embed/Qq2ww-icYUE',
      years: '2018',
      nature: 'Installation immersive',
      techniques: 'scénographie, lumière, captation, écriture de science-fiction conceptuelle',
      description: 'Dans "Continuum", Félicie d’Estienne d’Orves a imaginé un film en hommage à la pionnière de la musique électronique Éliane Radigue née en 1932. Son installation immersive réalisée à partir d’images prises par les sondes de la NASA montre un coucher de soleil sur Mars accompagnant "Koumé", la troisième partie de "Trilogie de la mort". ',
      links: ['https://www.feliciedestiennedorves.com/'],
    },
                        {
      id: 7,
      name: 'Hyperphantasia',
      artist: 'Justine Emard',
      image: '/media/references/JustineEmard/P1161842-scaled.jpg',
      images: ['/media/references/JustineEmard/P1161842-scaled.jpg', '/media/references/JustineEmard/P1161838-scaled.jpg', '/media/references/JustineEmard/6-Hyperphantasia-©Justine-Emard-1-1-scaled.jpg'],
      embedUrl: 'https://www.youtube.com/embed/zvYYkGRhBn4&t',
      years: '2022',
      nature: 'Installation',
      techniques: 'projection, sculptures',
      description: 'Depuis les profondeurs de la grotte jusqu’à celle de notre cerveau, Hyperphantasia créé un espace de rencontre entre 36 000 ans de technologies d’images, à la recherche de l’origine des images. - Une production Le Fresnoy, studio national des arts contemporains, projet réalisé dans le cadre de la résidence hors les murs de l’Observatoire de l’Espace, le laboratoire culturel du CNES.',
      links: ['https://justineemard.com/hyperphantasia/'],
    },
                            {
      id: 8,
      name: 'Supraorganism',
      artist: 'Justine Emard',
      image: '/media/references/JustineEmard/7D8A0407-OK-940x627.jpg',
      images: ['/media/references/JustineEmard/7D8A0407-OK-940x627.jpg', '/media/references/JustineEmard/2-Supraorganism-Justine-Emard-©-Adagp-Paris-2021-photo-by-Caroline-Lessire-940x626.jpg', '/media/references/JustineEmard/3_Supraorganism-©-Justine-Emard-ADAGP-2021-940x627.jpg', '/media/references/JustineEmard/6_Supraorganism-©-Justine-Emard-ADAGP-2021-940x627.jpg'],
      embedUrl: 'https://www.youtube.com/embed/syA6uD0qkHY',
      years: '2020',
      nature: 'Installation',
      techniques: 'programmation, moteurs, lumières, cloches en verre',
      description: 'Supraorganism est une installation réactive composée de sculptures en verre robotisées,  animées par un système de machine learning (une intelligence artificielle), et élaborée à partir de données collectées dans une communauté d’abeilles.',
      links: ['https://justineemard.com/supraorganism/'],
    },
                                {
      id: 9,
      name: 'A hard white body, a soft white worm',
      artist: 'Candice Lin',
      image: '/media/references/CandiceLin/Candice_Lin01-b.jpg',
      images: ['/media/references/CandiceLin/Candice_Lin01-b.jpg', '/media/references/CandiceLin/Candice_Lin23-b.jpg', '/media/references/CandiceLin/Candice_Lin09-b.jpg', '/media/references/CandiceLin/18892.jpg'],
      years: '2018',
      nature: 'Installation',
      techniques: 'scénographie, matières organiques, projection, lumières, textes, dessins',
      description: 'Candice Lin is known for her inventive use of materials, exploring their physical, sensory, and symbolic properties, from scent to taste, to question the colonial histories embedded within them. Presented at Portikus Frankfurt, A Hard White Body, a Soft White Worm unfolded as a fragmented environment of broken porcelain, textiles, clothing, books, and organic matter, reflecting on loss, displacement, and precarious forms of existence. Through these fragments, Lin traced new genealogies across the lives of James Baldwin, Jeanne Baret, and Maria Sibylla Merian, figures separated by time and geography yet connected by complex relations of race, gender, knowledge, and power. Their histories were interwoven with non-human agents - porcelain, plants, and insects - revealing the cultural and colonial narratives carried by materials. ',
      links: ['https://artviewer.org/candice-lin-at-portikus/'],
    },
                                    {
      id: 10,
      name: 'Retina',
      artist: 'Herman Kolgen',
      image: '/media/references/HermanKolgen/Retina-Instal-02a2-405x257.jpg',
      images: ['/media/references/HermanKolgen/maxresdefault.jpg', '/media/references/HermanKolgen/RETINA-TrypticW_22-405x257.jpg', '/media/references/HermanKolgen/Retina-hk_129.jpg'],
      embedUrl: 'https://www.youtube.com/embed/TKLwuStdMAs',
      years: '2019',
      nature: 'Installation vidéo',
      techniques: 'tryptique vidéo, programmation',
      description: 'Via cette frontière ouverte qu`est notre oeil, Herman Kolgen sonde la coexistence de l`humain et de ses territoires intermédiaires.',
      links: ['https://kolgen.net/fr/performances/retina-performance/'],
    },
                                        {
      id: 11,
      name: 'It’s late and the wind carries a faint sound as it moves…',
      artist: 'Ugo Rondinone',
      image: '/media/references/UgoRondinone/W1siZiIsIjE5NTUzNiJdLFsicCIsImNvbnZlcnQiLCItcXVhbGl0eSA5MCAtcmVzaXplIDIwMDB4MTQ0MFx1MDAzZSJdXQ.jpg',
      images: ['/media/references/UgoRondinone/W1siZiIsIjE5NTUzNiJdLFsicCIsImNvbnZlcnQiLCItcXVhbGl0eSA5MCAtcmVzaXplIDIwMDB4MTQ0MFx1MDAzZSJdXQ.jpg', '/media/references/UgoRondinone/téléchargement.png', '/media/references/UgoRondinone/64bd99af.jpg'],
      // embedUrl: '',
      years: '1999',
      nature: 'Installation immersive',
      techniques: '6 projections vidéos, lumières colorées, narration fragmentée',
      description: 'It`s late and the wind carries a faint sound as it moves through the trees. It could be anything. The jingling of little bells perhaps, or the tiny flickering out of tiny lives. I stroll down the sidewalk and close my eyes and open them and wait for my, mind to go perfectly blank. Like a room no one has ever entered, a room without any doors or windows. A place where nothing happens.',
      links: [''],
    },
                                            {
      id: 12,
      name: 'Interiors',
      artist: 'Doug Aitken',
      image: '/media/references/DougAitken/Screenshot_1.jpg',
      images: ['/media/references/DougAitken/Screenshot_1.jpg', '/media/references/DougAitken/827aff502fb039bd61a6c968d1365aa6f4c97414.webp', '/media/references/DougAitken/W1siZiIsIjExNzQ5NCJdLFsicCIsImNvbnZlcnQiLCItcXVhbGl0eSA5MCAtcmVzaXplIDIwMDB4MjAwMFx1MDAzZSJdXQ.jpg'],
      embedUrl: 'https://www.dailymotion.com/embed/video/x2ppdyb',
      years: '1999',
      nature: 'Installation immersive',
      techniques: '3 projections vidéos, 11 écrans translucides, lumières colorées, narration fragmentée',
      description: 'In this video installation, eleven large translucent screens are arranged to form a Greek cross around a space containing a circular bench. Projections appear at the far ends of three of the rooms created by the screens: in alternating narratives a young woman walks through a city, plays handball, and stands in front of open water; a man works in a helicopter factory and at one point begins to tap dance; a different man strolls through a city and stands near the water; a younger man walks through a city; a seated older man chants loudly; and a couple with a baby walks near a harbor.',
      links: [],
    },
                                                {
      id: 13,
      name: 'Stations',
      artist: 'Bill Viola',
      image: '/media/references/BillViola/2139_10.jpg',
      images: ['/media/references/BillViola/2139_10.jpg', '/media/references/BillViola/Amos-RexTU-210918-bill-viola-019-1600x1068.jpg', '/media/references/BillViola/bill-viola-ascension-video-1_medium.jpg'],
      embedUrl: 'https://www.youtube.com/embed/gkIMBV0W2Jk',
      years: '1994',
      nature: 'Installation vidéo',
      techniques: '5 projections vidéo',
      description: 'Stations is composed of five video projections (three are pictured here), each displaying a nude figure suspended in water, accompanied by a lulling soundtrack of underwater hums and deep basal drones. Floating heads down, the figures drift slowly out of the image frames. Their reflections in the polished slabs of granite at the foot of the screens give the impression of figures swimming in pools of dark liquid. In this work there is no beginning or end.',
      links: [],
    },
                                                    {
      id: 14,
      name: 'The Veiling',
      artist: 'Bill Viola',
      image: '/media/references/BillViola/65251170_10162303025475571_8623312518024003584_n.jpg',
      images: ['/media/references/BillViola/65251170_10162303025475571_8623312518024003584_n.jpg', '/media/references/BillViola/FWM_BV_5490_LR.jpg'],
      embedUrl: 'https://www.youtube.com/embed/LpfNhIVDHZQ',
      years: '1995',
      nature: 'Installation vidéo',
      techniques: '2 projections vidéo, écrans translucides suspendus, bande sonore',
      description: 'Images of a man and a woman can be seen slowly walking toward each other, passing through the scrims, and merging at the center before moving apart again. This ghostly action, repeating over and over, becomes hypnotic.',
      links: [],
    },
                                                        {
      id: 15,
      name: 'Tech/gnosis',
      artist: 'Tony Oursler',
      image: '/media/references/TonyOursler/TonyOursler_Specular_Installationsansicht_KunstraumDornbirn_2021_Foto-Günter-Richard-Wett-12.jpg',
      images: ['/media/references/TonyOursler/TonyOursler_Specular_Installationsansicht_KunstraumDornbirn_2021_Foto-Günter-Richard-Wett-12.jpg', '/media/references/TonyOursler/IMG_2089.webp', '/media/references/TonyOursler/tony-oursler-2016-2000x1500.jpg', '/media/references/TonyOursler/IMG_1965.webp', '/media/references/TonyOursler/IMG_2227.webp'],
      embedUrl: 'https://www.youtube.com/embed/5HjR1X0a4e4',
      years: '2026',
      nature: 'Installation vidéo',
      techniques: 'projections vidéo, mapping vidéo',
      description: '',
      links: [],
    },
                                                            {
      id: 16,
      name: 'Fire Piece',
      artist: 'Nam June Paik',
      image: '/media/references/NamJunePaik/8758.jpg',
      images: ['/media/references/NamJunePaik/8758.jpg', '/media/references/NamJunePaik/826832407-aa45a07157455e6ab77218808806d667d201607f6e403b303e6629161f6762de-d_640.avif', '/media/references/NamJunePaik/MAMCO-PaikN-2019-194.jpg'],
      embedUrl: 'https://www.youtube.com/embed/GbkoezYbKgk',
      years: '1992',
      nature: 'Installation vidéo',
      techniques: 'télévisions cathodiques, ensemble de débris de télévisions cathodiques',
      description: 'Réalisée en 1992 par le pionnier de l’art vidéo Nam June Paik, « Fire Piece » est une installation vidéo de grande ampleur. Elle se compose de télévisions noires qui diffusent toutes des images d’un feu en couleur. Paik (né en Corée en 1932 et mort à Miami en 2006) utilise la télévision, objet fétiche de son art, à la fois comme une forme à part entière et comme outil de diffusion d’images. Le tas d’objets technologiques dont se détachent les images mouvantes et colorées illustre particulièrement bien ce rapport entre l’objet télévisuel – sculpture, si l’on veut – et la diffusion d’images -le feu et la couleur.',
      links: [],
    },
                                                                {
      id: 17,
      name: 'The Whirlpool',
      artist: 'Yehwan Song',
      image: '/media/references/YehwanSong/72720a8f-62db-44d0-acd2-34983b43600e_866_1300.webp',
      images: ['/media/references/YehwanSong/72720a8f-62db-44d0-acd2-34983b43600e_866_1300.webp', '/media/references/YehwanSong/473734145_18485814010014984_6685928804896459922_n.jpg', '/media/references/YehwanSong/479492891_18491104126014984_1676509226293209826_n.jpg'],
      // embedUrl: 'https://www.youtube.com/embed/GbkoezYbKgk',
      years: '2025',
      nature: 'Installation vidéo, programmation',
      techniques: 'multiples écrans, structure métallique',
      description: 'The work 〈The Whirlpools〉 explains the conditions that emerge when the internet is understood as an environment by drawing on a natural phenomenon. The form of the whirlpool serves as a metaphor for how the internet, once imagined as an open ocean of information, has transformed into a structure that confines users within filter bubbles and informational valleys rather than allowing free and unrestricted movement. Within this flow, the user becomes less a subject who chooses and navigates, and more a body pulled in a predetermined direction.',
      links: ['https://yhsong.com/', 'https://www.instagram.com/yehwan.yen.song/?hl=fr'],
    },
                                                                    {
      id: 18,
      name: 'Cornucopia',
      artist: 'Björk',
      image: '/media/references/Bjork/BC_17 1.jpg',
      images: ['/media/references/Bjork/BC_17 1.jpg', '/media/references/Bjork/Bjork_Q7_2-scaled.jpg', '/media/references/Bjork/Bjork_dezeen_2364_col_0-1704x1136.webp'],
      embedUrls: [
      'https://www.youtube.com/embed/opQLkYnqEfw?si=mdW6GoHUISa1z6bj&t=71',
      'https://www.youtube.com/embed/tX4JmVav8Ls?si=v8ZfLHwafyRi6dfG&t=83',
      ],
  // embedUrl: ['https://www.youtube.com/embed/opQLkYnqEfw?si=mdW6GoHUISa1z6bj&t=71', 'https://www.youtube.com/embed/tX4JmVav8Ls?si=v8ZfLHwafyRi6dfG&t=83'],
      years: '2019',
      nature: 'Installation scénique monumentale, programmation',
      techniques: 'multiples projections, voiles, rideaux de fils, projections lumineuses',
      description: 'La tournée Cornucopia a été une expérience transformatrice inspirée par une décennie d’exploration par Björk des technologies immersives, du son à 360 degrés et de la réalité virtuelle. Ce projet fusionnait l’intimité théâtrale du XIXe siècle avec les innovations technologiques du XXIe. Les spectateurs étaient fascinés par 27 rideaux mobiles, des projections dynamiques, des écrans LED et des instruments tels qu’une harpe magnétique et une flûte circulaire, tous conçus pour intensifier l’impact émotionnel des performances. Au cœur du spectacle se trouvait un avatar moderne, une marionnette alchimique symbolisant un parcours de guérison et de transformation.',
      links: ['https://www.bjork.fr/'],
    },
                                                                        {
    id: 19,
      name: 'La Mer',
      artist: 'Ange Leccia',
      image: '/media/references/AngeLeccia/Ange_Leccia_La_Mer.jpg',
      images: ['/media/references/AngeLeccia/Ange_Leccia_La_Mer.jpg', '/media/references/AngeLeccia/2019_la_mer-ange_leccia_2048x1024-1_large.jpg', '/media/references/AngeLeccia/cda23_ange_leccia_mer-tt-width-653-height-482-fill-0-crop-0-bgcolor-eeeeee.jpg'],
      // embedUrl: ['https://www.youtube.com/embed/opQLkYnqEfw?si=mdW6GoHUISa1z6bj&t=71', 'https://www.youtube.com/embed/tX4JmVav8Ls?si=v8ZfLHwafyRi6dfG&t=83'],
      years: '1991',
      nature: 'Installation immersive',
      techniques: 'projections vidéo monumentales, bande sonore',
      description: 'Allégorie de la vie, le flux marin renvoie aux battements lumineux visibles dans de nombreuses oeuvres d’Ange Leccia. Ce flux silencieux met au diapason le cours de l’existence et la pulsation de la nature. Il est un pouls qui ne s’entend pas mais s’observe.',
      links: [''],
    },
                                                                            {
    id: 19,
      name: 'Artificial Botany',
      artist: 'fuse*',
      image: '/media/references/fuse/fuseArtificialBotany.jpg',
      images: ['/media/references/fuse/fuseArtificialBotany.jpg', '/media/references/fuse/fuseArtificialBotany2.jpg', '/media/references/fuse/fuseArtificialBotany3.jpg', '/media/references/fuse/fuseArtificialBotany4.jpg'],
      embedUrl: 'https://player.vimeo.com/video/394932646',
      years: '2020',
      nature: 'Installation',
      techniques: 'tryptique d’écrans, bande sonore immersive, programmation',
      description: 'Artificial Botany is an ongoing project which explores the latent expressive capacity of botanical illustrations through the use of machine learning algorithms.',
      links: ['https://www.fuseworks.it/artworks'],
    },
                                                                                {
    id: 20,
      name: 'Archive Dreaming',
      artist: 'Refik Anadol',
      image: '/media/references/RefikAnadol/ArchiveDreaming2.jpg',
      images: ['/media/references/RefikAnadol/ArchiveDreaming2.jpg', '/media/references/RefikAnadol/VirtualArchive.jpg', '/media/references/RefikAnadol/VirtualArchive2.jpg', '/media/references/RefikAnadol/VirtualArchive4.jpg', '/media/references/RefikAnadol/ArchiveDreaming.jpg'],
      embedUrl: 'https://player.vimeo.com/video/218573298?fl=pl&fe=cm',
      years: '2017',
      nature: 'Installation immersive et interactive',
      techniques: 'A.I. Data sculpture, programmation, projection visuelle en 360°',
      description: 'Commissioned to work with SALT Research collections, artist Refik Anadol employed machine learning algorithms to search and sort relations among 1,700,000 documents. Interactions of the multidimensional data found in the archives are, in turn, translated into an immersive media installation. In this project, a temporary immersive architectural space is created as a canvas with light and data applied as materials. This radical effort to deconstruct the framework of an illusory space will transgress the normal boundaries of the viewing experience of a library and the conventional flat cinema projection screen, into a three dimensional kinetic and architectonic space of an archive visualized with machine learning algorithms.',
      links: ['https://www.fuseworks.it/artworks'],
    },
                                                                                    {
    id: 21,
      name: 'Forty Part Motet',
      artist: 'Janet Cardiff',
      image: '/media/references/JanetCardiff/JanetCardiff2.webp',
      images: ['/media/references/JanetCardiff/JanetCardiff2.webp', '/media/references/JanetCardiff/JanetCardiff3.jpg'],
      embedUrl: 'https://www.youtube.com/embed/38ORiaia9r8&t',
      years: '2001',
      nature: 'Installation sonore',
      techniques: 'spatialisation sonore, 40 enceintes',
      description: 'Janet Cardiff is a Canadian artist who works chiefly with sound and sound installations; especially a form she calls audio walks. Her artwork "Forty Part Motet" is an audio installation reworking the sixteenth-century choral work Spem in Alium by English composer Thomas Talli. The artist worked with the Salisbury Cathedral Choir to record 40 individual singers, playing each voice through its own corresponding speaker. The speakers are carefully positioned in eight different groups of five, responding to the structure of Tallis’s complex vocal piece, or motet. Each group forms a choir of five singers with different vocal ranges: a bass, baritone, tenor, alto and soprano.',
      links: ['https://cardiffmiller.com/'],
    },
                                                                                        {
    id: 22,
      name: 'Desert Soundscapes',
      artist: 'Ammar Khammash',
      image: '/media/references/AmmarKhammash/csm_02-3-B_680bef0b95.jpg',
      images: ['/media/references/AmmarKhammash/csm_02-3-B_680bef0b95.jpg', '/media/references/AmmarKhammash/UnFinishedRooms.jpg', '/media/references/AmmarKhammash/IMG_2288.jpg', '/media/references/AmmarKhammash/IMG_2287.jpg'],
      embedUrl: 'https://www.youtube.com/embed/wMYw92V1-oI&t',
      years: '2017',
      nature: 'Installation sonore',
      techniques: 'rochers, moteurs, électronique, programmation, projection, photographie, casques',
      description: 'Desert Soundscapes is an exhibition by architect and artist Ammar Khammash where he explores the landscape of Jordan and Palestine to unearth a hidden order, a secret code, or an undiscovered musical scale hidden in the millions of flints in the desert.',
      links: [''],
    },
                                                                                            {
    id: 23,
      name: 'Helikopter Streichquartett',
      artist: 'Karlheinz Stockhausen',
      image: '/media/references/KarlheinzStockhausen/Stockhousen2.jpg',
      images: ['/media/references/KarlheinzStockhausen/Stockhousen2.jpg', '/media/references/KarlheinzStockhausen/Stockhousen.jpeg', '/media/references/KarlheinzStockhausen/maxresdefault.jpg'],
      embedUrl: 'https://www.youtube.com/embed/7ykQFrL0X74&t=335s',
      years: '1995',
      nature: 'Installation sonore',
      techniques: 'quadriphonie',
      description: 'Helikopter-Streichquartett (Quatuor à cordes hélicoptère) est une œuvre de Karlheinz Stockhausen qui nécessite un quatuor à cordes, quatre hélicoptères et leurs pilotes, ainsi qu`un équipement audio et vidéo et des techniciens.',
      links: [''],
    },
                                                                                                {
    id: 24,
      name: 'ÂMA',
      artist: 'Damien Traversaz',
      image: '/media/references/DamienTraversaz/2a5dce_d30a9b7c186d4d69adf2d9af8ad4e1e2~mv2.avif',
      images: ['/media/references/DamienTraversaz/2a5dce_d30a9b7c186d4d69adf2d9af8ad4e1e2~mv2.avif', '/media/references/DamienTraversaz/2a5dce_e888942f970b431190be837698dba518~mv2.avif', '/media/references/DamienTraversaz/2a5dce_5a9e37910422442092d19dab1a74bf55~mv2.avif'],
      embedUrl: 'https://player.vimeo.com/video/810955407?fl=pl&fe=vl&turnstile=1.7ryBg0XBz3oMDUb_7R2bvc9Vwz9TccPILc5GA8C7NvvAdQR6skc1uXuhUjyzFZ5RPSdDNMN3V4786NM6UjmnzTgC5I_hvnf6U4JZ3SzSi33xRQxmJR-I4wZ7M-dK96SdNvFsR6iR-YXVmIOGcxH9iaLalxpMXlxBkBotDyVulvoB3Ejvpg7mCfaZCfteJIkMtCUgFzbL7Rt-gbPre05nAySlQwjZJvK2wuGEPla28injd2VDuikyUqF7lv3f1epIzqWYfLCyxCcq1Y6LqW32npJZji4V5TE3W22SvfB0JqGADWNhNvkrbQkSpkKfTnQPmk-uIIIwpYnDfmNj5winTTnlyEcxLbue7nYu5cmK7fv4DPAM0Iy2SRjGEotHTcyyic2Sso64zeiv4XM_AGCRnOOkpzoQ7Gz4tLo1J02aH8BRFNlK4oHOESYs-DYxUhiHZh6NBLTF8LLFqKwK8mrqqMrQn5HYk5snyWxW6L8SbptNDScpKCw5NFfRpC3oyqcZEBniTZbTSBb0qYCzkGTI0gP_n9JE2Gc-hsRhBjP_hBXy-vGji6UN0MCyuJbIf494M1pvCC9_Q4S441cP7GppSHKW-tznEi-xFk4-cOofW7f6U2UYNJq9ErlLESthhO4xjj6kbn0vT61ubToYprBR7Q.oT43Nqdym_iOhzAYJuVlFw.8d3cda7eadcca9e9e4e970bfc5f21d7db2864243cb0acd8fc9ef027008cbf373',
      years: '2023',
      nature: 'Installation interactive',
      techniques: 'projection, pupitre en bois, plume, capteurs, bande sonore',
      description: 'ÂMA (âme en vieux savoyard) est une création sensible. Elle donne voix à un morceau de bois, issu de mes forêts. Les lignes naturelles évoquent une partition cachée, que l’on peut délicatement interpréter par le toucher. Par le contact d’une plume ou de la main, les nervures du bois se jouent, se parcourent, proposant une interprétation libre de leur courbures. Une grande finesse musicale est possible : le bois se lie au geste de l’archet et au son du violon. J’ai souhaité retrouver cette sensation de toucher et lui donner corps sonore, de la façon la plus naturelle possible. Le BOIS invite à l’exploration DES LIGNES que la nature nous propose. Mais aussi à nous écouter, en prenant le temps du geste musical. La création sonore est spatialisée, l’écoute se réalise au casque audio. ÂMA peut être présentée dans tout lieu, en différentes variations selon l’espace disponible : de l’œuvre en immersion visuelle, générée en temps réel dans un espace sombre, à une version purement acoustique et musicale.',
      links: ['https://www.damientraversaz.com/ama'],
    },
                                                                                                    {
    id: 25,
      name: 'ISOTOPP',
      artist: 'Herman Kolgen',
      image: '/media/references/HermanKolgen/KolgenIsotopp2.jpg',
      images: ['/media/references/HermanKolgen/KolgenIsotopp2.jpg', '/media/references/HermanKolgen/KolgenIsotopp3.jpg', '/media/references/HermanKolgen/KolgenIsotopp1.jpg', '/media/references/HermanKolgen/Isotopp2.jpg'],
      embedUrl: 'https://www.youtube.com/embed/BlP7M3FYATA',      
      years: '2019',
      nature: 'Installation',
      techniques: '3 écrans led, 1 écran circulaire translucide, projections vidéos, rubans led, programmation, bande sonore',
      description: 'A partir de sa rencontre avec les chercheurs du GANIL Jean-Charles Thomas puis Thomas Roger, Herman Kolgen a conçu un dispositif ayant pour objet une interprétation de l’activité de recherche du GANIL sous forme d’une performance et d’une installation visuelle et sonore. Pour étudier la structure atomique, le GANIL procède par collision de noyaux lancés à très grande vitesse. le principe est de projeter à 100 000 km/sec un faisceau de ions lourds (éléments chimiques dont le poids est situé entre celui d’un atome de carbone et celui d’un atome d’uranium) contre les noyaux cibles. les effets produits par ce bombardement sont enregistrés par des détecteurs, puis étudiés en détail par les chercheurs. Herman Kolgen conceptualise un dispositif qui vise à traduire les recherches menées au ganil, en transposant ces notions à partir de données concrètes pour créer des matières sonores et visuelles dynamiques.',
      links: ['https://kolgen.net/fr/installations/isotopp/'],
    },
                                                                                                        {
    id: 26,
      name: 'Métamorphy',
      artist: 'Scenocosme',
      image: '/media/references/Scenocosme/metamorphy_scenocosme_4.jpg',
      images: ['/media/references/Scenocosme/metamorphy_scenocosme_4.jpg', '/media/references/Scenocosme/metamorphy_limay10.jpg', '/media/references/Scenocosme/metamorphy_limay14.jpg', '/media/references/Scenocosme/metamorphy_limay11.jpg', '/media/references/Scenocosme/metamorphy_scenocosme_2.jpg'],
      embedUrl: 'https://www.youtube.com/embed/cqzu_Z8ZEtI&t',    
      years: '',
      nature: 'Installation interactive',
      techniques: '1 écran circulaire translucide, projection vidéo, caméra de profondeur, programmation, bande sonore',
      description: 'Métamorphy est une oeuvre interactive, visuelle et sonore. Les spectateurs sont invités a toucher et explorer la profondeur du voile semi-transparent de l’installation. Cette peau symbolique possède une élasticité qui s’inscrit dans le processus de la métamorphose : elle se déforme lorsque le spectateur la touche, et reprend sa rigidité lorsqu’il la relâche.',
      links: ['chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj/https://www.scenocosme.com/PDF/metamorphy_FR.pdf', 'https://www.scenocosme.com/metamorphy.htm'],
    },
                                                                                                            {
    id: 27,
      name: 'Reliquiae Mirabilis',
      artist: 'Scenocosme, Yosra Mojtahedi',
      image: '/media/references/Scenocosme/reliquiae(1).jpg',
      images: ['/media/references/Scenocosme/metamorphy_scenocosme_4.jpg', '/media/references/Scenocosme/reliquiae(6).jpg', '/media/references/Scenocosme/reliquiae(2).jpg', '/media/references/Scenocosme/reliquiae_mirabilis(5).jpg', '/media/references/Scenocosme/reliquiae_mirabilis(3).jpg'],
      embedUrl: 'https://www.youtube.com/embed/xwGODSZy_OE&t',    
      years: '',
      nature: 'Installation interactive',
      techniques: 'projection vidéo, sculpture interactive, capteurs, bande sonore, programmation, performance, dessins augmentés',
      description: 'Cette sculpture interactive est réalisée à partir de branches d’arbres mortes prélevées dans la forêt. L’arbre sculpture ainsi reconstitué reprend vie symboliquement. Un dispositif interactif (ordinateur + microcontrôleur + capteurs + pompe à eau) fait s’écouler un liquide olfactif, le long de son écorce extérieur et de ses entrailles, de sa cime jusqu’à ses racines qui baignent dans un réceptacle. Le liquide suinte, perle, ruisselle minutieusement, lentement ou rapidement en fonction de l’approche des publics. Un délicat parfum charnel et floral s’en échappe délicatement.',
      links: ['https://www.scenocosme.com/reliquiae.htm'],
    },
  ];

  // Initialiser avec le tableau de bord ouvert (pas de sélection)
  useEffect(() => {
    // On arrive sur le tableau de bord — pas de sélection automatique
  }, []);

  // Scroll du carousel → scrollbar
  useEffect(() => {
    const handleScroll = () => {
      const carousel = carouselRef.current;
      if (carousel) {
        const maxScroll = carousel.scrollHeight - carousel.clientHeight;
        const progress  = maxScroll > 0 ? carousel.scrollTop / maxScroll : 0;
        setScrollProgress(progress);
      }
    };
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.addEventListener('scroll', handleScroll);
      handleScroll();
      return () => carousel.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const scrollToRef = (refId) => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const idx = references.findIndex(r => r.id === refId);
    if (idx === -1) return;
    const itemH = 210;
    const target = idx * itemH - carousel.clientHeight / 2 + itemH / 2;
    carousel.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  };

  const handleRefClick = (ref) => {
    setSelectedRef(ref);
    if (isDashboardOpen) {
      setIsDashboardOpen(false);
      setTimeout(() => scrollToRef(ref.id), 300);
    }
  };

  const scrollToPosition = (pct) => {
    const carousel = carouselRef.current;
    if (carousel) {
      const maxScroll = carousel.scrollHeight - carousel.clientHeight;
      carousel.scrollTo({ top: maxScroll * pct, behavior: 'smooth' });
    }
  };

  // Drag scrollbar
  const handleMouseDown = (e) => { e.preventDefault(); setIsDragging(true); };
  const handleMouseMove = (e) => {
    if (!isDragging || !scrollbarRef.current) return;
    const rect = scrollbarRef.current.getBoundingClientRect();
    const pct  = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));
    const carousel = carouselRef.current;
    if (carousel) carousel.scrollTop = (carousel.scrollHeight - carousel.clientHeight) * pct;
  };
  const handleMouseUp = () => setIsDragging(false);

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
      };
    }
  }, [isDragging]);

  // Références triées alphabétiquement par nom
  const sortedReferences = [...references].sort((a, b) =>
    a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' })
  );

  const getRefState = (ref) => {
    if (selectedRef && ref.id === selectedRef.id) return 'selected';
    if (hoveredRef  && ref.id === hoveredRef.id)  return 'hovered';
    return 'default';
  };

  return (
    <div className="ref-container">
      <NavigationMenu />
      <LogoBlanc />

      <div className="ref-page-title">
        <p className="ref-title-text">Répertoire de références</p>
      </div>

      {/* ── Bouton tableau de bord ── */}
      <div className="ref-dashboard-toggle" onClick={() => setIsDashboardOpen(o => !o)}>
        <div className="ref-dashboard-icon">
          <div className="ref-grid-icon">
            {Array.from({ length: 9 }).map((_, i) => (
              <div key={i} className="ref-grid-cell" />
            ))}
          </div>
        </div>
        <span className="ref-dashboard-label">Tableau de bord</span>
      </div>

      {/* ── Tableau de bord pop-up ── */}
      {isDashboardOpen && (
        <div className="ref-dashboard-overlay">
          <div className="ref-dashboard-container">
            <div className="ref-dashboard-header">
              <h2 className="ref-dashboard-title">Tableau de bord des références</h2>
              <button className="ref-dashboard-close" onClick={() => setIsDashboardOpen(false)}>✕</button>
            </div>
            <div className="ref-dashboard-grid">
              {sortedReferences.map((ref) => (
                <div
                  key={ref.id}
                  className={`ref-dashboard-item${selectedRef && ref.id === selectedRef.id ? ' ref-dashboard-item--selected' : ''}`}
                  onClick={() => handleRefClick(ref)}
                  onMouseEnter={() => setHoveredDashItem(ref.id)}
                  onMouseLeave={() => setHoveredDashItem(null)}
                >
                  <img className="ref-dashboard-image" src={ref.image} alt={ref.name} />
                  {/* Texte permanent en haut à gauche */}
                  <div className="ref-dashboard-label-wrap">
                    <span className="ref-dashboard-name">{ref.name}</span>
                    <span className="ref-dashboard-artist">{ref.artist}</span>
                    {/* Supplément au hover */}
                    {hoveredDashItem === ref.id && (
                      <span className="ref-dashboard-extra">{ref.years} · {ref.nature}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── Panneau de détail ── */}
      <div className="ref-main-grid">
        <div className="ref-detail-panel">
          {selectedRef ? (
            <div className="ref-detail-content">

              {/* En-tête */}
              <div className="ref-detail-header">
                <div className="ref-experiment-info">
                  <h2 className="ref-experiment-title">{selectedRef.name}</h2>
                  <div className="ref-experiment-meta">
                    <span className="ref-experiment-subtitle">{selectedRef.artist}</span>
                  </div>
                </div>
              </div>

              {/* Corps scrollable */}
              <div className="ref-detail-body">

                {/* Images + vidéo */}
                <div className="ref-media-section">
                  {selectedRef.images && selectedRef.images.map((img, i) => (
                    <img key={i} className="ref-media-img" src={img} alt={`${selectedRef.name} ${i + 1}`} />
                  ))}
                  {selectedRef.embedUrls && selectedRef.embedUrls.map((url, i) => (
                    <div key={i} className="ref-embed-wrapper">
                      <iframe
                        src={url}
                        className="ref-embed"
                        allowFullScreen
                        allow="autoplay; fullscreen"
                        title={`${selectedRef.name} ${i + 1}`}
                      />
                    </div>
                  ))}
                  {/* Rétrocompatibilité avec l'ancien champ embedUrl */}
                  {selectedRef.embedUrl && !selectedRef.embedUrls && (
                    <div className="ref-embed-wrapper">
                      <iframe
                        src={selectedRef.embedUrl}
                        className="ref-embed"
                        allowFullScreen
                        allow="autoplay; fullscreen"
                        title={selectedRef.name}
                      />
                    </div>
                  )}
                </div>

                {/* Métadonnées */}
                <div className="ref-metadata-section">

                  {selectedRef.years && (
                    <div className="ref-metadata-block">
                      <h3 className="ref-metadata-title">Année de parution</h3>
                      <p className="ref-metadata-text">{selectedRef.years}</p>
                    </div>
                  )}

                  {selectedRef.nature && (
                    <div className="ref-metadata-block">
                      <h3 className="ref-metadata-title">Nature de l'œuvre</h3>
                      <p className="ref-metadata-text">{selectedRef.nature}</p>
                    </div>
                  )}

                  {selectedRef.techniques && (
                    <div className="ref-metadata-block">
                      <h3 className="ref-metadata-title">Techniques</h3>
                      <p className="ref-metadata-text">{selectedRef.techniques}</p>
                    </div>
                  )}

                  {selectedRef.description && (
                    <div className="ref-metadata-block">
                      <h3 className="ref-metadata-title">Brève description</h3>
                      <p className="ref-metadata-text">{selectedRef.description}</p>
                    </div>
                  )}

                  {selectedRef.links && selectedRef.links.length > 0 && (
                    <div className="ref-metadata-block">
                      <h3 className="ref-metadata-title">Liens web</h3>
                      <div className="ref-links">
                        {selectedRef.links.map((link, i) => (
                          <a key={i} href={link} target="_blank" rel="noreferrer" className="ref-link">
                            {link}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
          ) : (
            <div className="ref-detail-empty">
              <p>Sélectionnez une référence dans le tableau de bord ou dans la liste.</p>
            </div>
          )}
        </div>
      </div>

      {/* ── Carousel vertical (liste gauche) ── */}
      <div className="ref-carousel-container">
        <div
          ref={scrollbarRef}
          className="ref-carousel-scrollbar"
          onClick={(e) => {
            if (!isDragging) {
              const rect = e.currentTarget.getBoundingClientRect();
              scrollToPosition((e.clientY - rect.top) / rect.height);
            }
          }}
        >
          <div
            className="ref-scrollbar-indicator"
            style={{ top: `${Math.min(scrollProgress * 80, 80)}%`, cursor: isDragging ? 'grabbing' : 'grab' }}
            onMouseDown={handleMouseDown}
          />
        </div>

        <div ref={carouselRef} className="ref-carousel-content">
          {sortedReferences.map((ref) => {
            const state = getRefState(ref);
            return (
              <div
                key={ref.id}
                className={`ref-carousel-item ref-carousel-item--${state}`}
                onClick={() => handleRefClick(ref)}
                onMouseEnter={() => setHoveredRef(ref)}
                onMouseLeave={() => setHoveredRef(null)}
              >
                <img
                  className="ref-carousel-image"
                  src={ref.image}
                  alt={ref.name}
                />
                {/* Pas d'overlay texte au hover — juste la couleur revient */}
                <div className="ref-series-indicator">
                  <span className="ref-indicator-name">{ref.name}</span>
                  <span className="ref-indicator-artist">{ref.artist}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default References;